module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Serveis a la recepció ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consell veterinari gratuït")]), _vm._v(" "), _c('p', [_vm._v("Us escoltem")]), _vm._v(" "), _c('p', [_vm._v("Us oferim una solució global personalitzada")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Venda")]), _vm._v(" "), _c('p', [_vm._v("Només oferim productes d'alta qualitat que hem estudiat i provat")]), _vm._v(" "), _c('p', [_vm._v("Garantim en tots els productes el preu més baix en el mercat")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b74ffaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cat/ServicesHome.vue
// module id = 145
// module chunks = 0